import { Button, Carousel, Form, Input } from 'antd';
import { useRouterTarget } from '&/utils/customHooks';
import { observer, inject } from 'mobx-react';
import * as Sentry from '@sentry/react';
import Logoes from './Logoes';
import AboutFoxit from './AboutFoxit';
import { businessCreate } from '&/api/landing';
import { getSMSVerificationCode } from '&/api/Dialogs/signUpDlg';
import ServiceModal from '&/components/ServiceModal';
// import { createProject } from '@/api/landingPage/index';

import './LandingPage.scss';
const { Item } = Form;

export default inject('appStore')(
    observer(function LandingPage(props) {
        const carouselRef = useRef();
        const carouselRef1 = useRef();
        const [codeForm] = Form.useForm();
        const [isClicked, setisClicked] = useState(false); // 是否已经点击发送
        const [count, setcount] = useState(60); // 多少秒后可以再次发送
        const [loading, setloading] = useState(false);
        const [isModalOpen, setIsModalOpen] = useState(false);

        const onVerification = values => {
            setloading(true);
            values.type = 2;
            businessCreate(values)
                .then(({ data }) => {
                    Sentry.withScope(function (scope) {
                        scope.setFingerprint([
                            '{{ default }}',
                            values.mobile,
                            data.id,
                        ]);
                        Sentry.captureMessage(
                            `applications：【一对一服务】[${data.id}] ${values.fullName} ${values.mobile} ${window.location.origin}`,
                            'info'
                        );
                    });
                    setIsModalOpen(true);
                })
                .finally(setloading.bind(null, false));
        };

        const sendCode = async () => {
            await codeForm.validateFields(['mobile']);
            const mobile = codeForm.getFieldValue('mobile');
            await getSMSVerificationCode({
                mobile,
                type: 'LAND',
            });
            setisClicked(true);
            let time = count;
            const timmer = setInterval(() => {
                time--;
                setcount(time);
                if (time !== 0) return;
                clearInterval(timmer);
                setcount(60);
                setisClicked(false);
            }, 1e3);
        };

        const HEADER_LIST = [
            {
                img: require('@/assets/img/landing/Icon_Gift.png').default,
                title: intl.get('landingPage.landingPage.message1'),
                subTitle: intl.get('landingPage.landingPage.message2'),
            },
            {
                img: require('@/assets/img/landing/Icon_Project.png').default,
                title: intl.get('landingPage.landingPage.message3'),
                subTitle: intl.get('landingPage.landingPage.message4'),
            },
            {
                img: require('@/assets/img/landing/Icon_Security.png').default,
                title: intl.get('landingPage.landingPage.message5'),
                subTitle: intl.get('landingPage.landingPage.message6'),
            },
            {
                img: require('@/assets/img/landing/Icon_Template.png').default,
                title: intl.get('landingPage.landingPage.message7'),
                subTitle: intl.get('landingPage.landingPage.message8'),
            },
        ];
        const TABS = [
            {
                key: 1,
                content: {
                    img: require('@/assets/img/landing/4-1.png').default,
                },
                title: intl.get('landingPage.landingPage.message9'),
                desc: intl.get('landingPage.landingPage.message10'),
            },
            {
                key: 2,
                content: {
                    img: require('@/assets/img/landing/4-2.png').default,
                },
                title: intl.get('landingPage.landingPage.message11'),
                desc: intl.get('landingPage.landingPage.message12'),
            },
            {
                key: 3,
                content: {
                    img: require('@/assets/img/landing/4-3.png').default,
                },
                title: intl.get('landingPage.landingPage.message13'),
                desc: intl.get('landingPage.landingPage.message14'),
            },
            {
                key: 4,
                content: {
                    img: require('@/assets/img/landing/4-4.png').default,
                },
                title: intl.get('landingPage.landingPage.message15'),
                desc: intl.get('landingPage.landingPage.message16'),
            },
        ];
        const TABS_2 = [
            {
                key: 1,
                content: {
                    img: require('@/assets/img/landing/3-1.png').default,
                },
                title: intl.get('landingPage.landingPage.message17'),
                desc: intl.get('landingPage.landingPage.message18'),
            },
            {
                key: 2,
                content: {
                    img: require('@/assets/img/landing/3-2.png').default,
                },
                title: intl.get('landingPage.landingPage.message19'),
                desc: intl.get('landingPage.landingPage.message20'),
            },
            {
                key: 3,
                content: {
                    img: require('@/assets/img/landing/3-3.png').default,
                },
                title: intl.get('landingPage.landingPage.message21'),
                desc: intl.get('landingPage.landingPage.message22'),
            },
        ];

        const EXAMPLE_LIST = [
            {
                img: require('@/assets/img/landing/2-1.png').default,
                company: intl.get('landingPage.landingPage.message23'),
                achievement: intl.get('landingPage.landingPage.message24'),
                build: intl.get('landingPage.landingPage.message25'),
                desc: intl.get('landingPage.landingPage.message26'),
            },
            {
                img: require('@/assets/img/landing/2-2.png').default,
                company: intl.get('landingPage.landingPage.message27'),
                achievement: intl.get('landingPage.landingPage.message28'),
                build: intl.get('landingPage.landingPage.message29'),
                desc: intl.get('landingPage.landingPage.message30'),
            },
        ];

        const PROBLEM_LIST = [
            {
                title: intl.get('landingPage.landingPage.message31'),
                desc: intl.get('landingPage.landingPage.message32'),
                iconName: require('@/assets/img/landing/6-1.png').default,
            },
            {
                title: intl.get('landingPage.landingPage.tooLongTime'),
                desc: intl.get('landingPage.landingPage.message33'),
                iconName: require('@/assets/img/landing/6-2.png').default,
            },
            {
                title: intl.get('landingPage.landingPage.collaborate'),
                desc: intl.get('landingPage.landingPage.message34'),
                iconName: require('@/assets/img/landing/6-3.png').default,
            },
            {
                title: intl.get('landingPage.landingPage.overTime'),
                desc: intl.get('landingPage.landingPage.message35'),
                iconName: require('@/assets/img/landing/6-4.png').default,
            },
            {
                title: intl.get('landingPage.landingPage.toManyProblem'),
                desc: intl.get('landingPage.landingPage.message36'),
                iconName: require('@/assets/img/landing/6-5.png').default,
            },
            {
                title: intl.get('landingPage.landingPage.expenditure'),
                desc: intl.get('landingPage.landingPage.message37'),
                iconName: require('@/assets/img/landing/6-6.png').default,
            },
        ];

        const targetPage = useRouterTarget();

        const navigateTo = key => {
            targetPage({
                pathname: `/landing/example`,
                search: { key },
            });
        };

        const handleFreeUse = () => {
            props.appStore.handleFreeUse(targetPage);
        };

        const [firstIndex, setFirstIndex] = useState(0);
        const [secondIndex, setSecondIndex] = useState(0);

        console.log(firstIndex, secondIndex);

        const handleCarouselChange = (index, type) => {
            if (type === 'first') {
                setFirstIndex(index);
            } else {
                setSecondIndex(index);
            }
        };

        const onMouseEnter = (idx, type) => {
            let carouse = type === 'first' ? carouselRef : carouselRef1;
            carouse.current.goTo(idx);
            carouse.current.innerSlider.pause('paused');
            carouse.current.autoPlay('paused');
        };

        return (
            <div className="landing-page">
                <div className="header">
                    <div className="header-flex">
                        <div className="flex-wrap">
                            <div className="left">
                                {/* <img
                                    src={
                                        require('@/assets/img/landing/image33.png')
                                            .default
                                    }
                                    alt="多端多角色协同"></img> */}
                                <div className="sub-title">
                                    限时免费，火热进行中~
                                </div>
                                <div className="large-title ">
                                    <img
                                        src={
                                            require('@/assets/img/landing/title.png')
                                                .default
                                        }
                                    />
                                </div>
                                <div className="sub-large-title">
                                    {intl.get(
                                        'landingPage.landingPage.message39'
                                    )}
                                </div>
                                <div style={{ display: 'none' }}>
                                    {intl.get(
                                        'landingPage.landingPage.message40'
                                    )}
                                </div>
                                <div style={{ display: 'none' }}>
                                    {intl.get(
                                        'landingPage.landingPage.message41'
                                    )}
                                </div>
                                <div className="btn-warp">
                                    <Button
                                        type="primary"
                                        shape="round"
                                        size={'large'}
                                        onClick={handleFreeUse}>
                                        {intl.get(
                                            'landingPage.landingPage.message42'
                                        )}
                                    </Button>
                                </div>
                            </div>
                            <div className="right">
                                <div style={{ display: 'none' }}>
                                    {intl.get(
                                        'landingPage.landingPage.message43'
                                    )}
                                </div>
                                <div style={{ display: 'none' }}>
                                    {intl.get(
                                        'landingPage.landingPage.message44'
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sub-box-wrap">
                        <div className="flex-box">
                            {HEADER_LIST.map((v, index) => {
                                return (
                                    <div className="box" key={index}>
                                        <img src={v.img} alt={v.title}></img>
                                        <div className="content">
                                            <div className="title">
                                                {v.title}
                                            </div>
                                            <div className="sub-title">
                                                {v.subTitle}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="five-core">
                    <div className="sub-content">
                        <div className="large-title">
                            <div style={{ display: 'none' }}>
                                {intl.get('landingPage.landingPage.message45')}
                            </div>
                            <div style={{ display: 'none' }}>
                                {intl.get('landingPage.landingPage.message46')}
                            </div>
                            {intl.get('landingPage.landingPage.message47')}
                            <img
                                className="spacial-word"
                                src={
                                    require('@/assets/img/landing/6-num.png')
                                        .default
                                }
                            />
                            {intl.get('landingPage.landingPage.message48')}
                        </div>
                        <div className="problem-wrap">
                            {PROBLEM_LIST.map((v, idx) => (
                                <div className="problem-item" key={idx}>
                                    <div
                                        className="item-title"
                                        style={{
                                            background: `url(${v.iconName})`,
                                            backgroundSize: 'cover',
                                        }}>
                                        {v.title}
                                    </div>
                                    <div
                                        className="item-desc"
                                        dangerouslySetInnerHTML={{
                                            __html: v.desc,
                                        }}></div>
                                </div>
                            ))}
                        </div>

                        <div className="large-title large-title-second">
                            {' '}
                            <h2 style={{ display: 'none' }}>
                                {intl.get('landingPage.landingPage.message49')}
                            </h2>
                            <h2 style={{ display: 'none' }}>
                                {intl.get('landingPage.landingPage.message50')}
                            </h2>
                            <div>
                                {intl.get('landingPage.landingPage.message51')}
                            </div>
                            <div>
                                {intl.get('landingPage.landingPage.message52')}
                            </div>
                        </div>

                        <img
                            className="pk"
                            src={require('@/assets/img/landing/pk.png').default}
                        />
                    </div>
                </div>
                <div className="section-three">
                    <div className="sub-content">
                        <div className="title1 title">
                            {intl.get('landingPage.landingPage.message53')}
                        </div>
                        <div className="title2 title">
                            {intl.get('landingPage.landingPage.message54')}
                        </div>
                    </div>
                </div>

                <div className="section-four">
                    <div className="sub-content">
                        <div className="large-title">
                            <div style={{ display: 'none' }}>
                                {intl.get('landingPage.landingPage.message55')}
                            </div>
                            <div style={{ display: 'none' }}>
                                {intl.get('landingPage.landingPage.message56')}
                            </div>
                            {intl.get('landingPage.landingPage.message57')}
                        </div>
                        <div className="sub-title">
                            {intl.get('landingPage.landingPage.message58')}
                        </div>

                        <div className="carousel-wrap">
                            <Carousel
                                // dots={{ className: 'custom-dot-landing-hdc' }}
                                autoplay
                                afterChange={cur =>
                                    handleCarouselChange(cur, 'first')
                                }
                                ref={carouselRef}>
                                {TABS.map((v, index) => (
                                    <div className="carousel-card" key={index}>
                                        <div className="tab-content">
                                            <img
                                                src={v.content.img}
                                                alt={v.title}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </Carousel>
                        </div>

                        <div className="dot-content-wrap">
                            {TABS.map((v, index) => (
                                <div
                                    className="dot-content-item"
                                    key={v.key}
                                    onClick={() =>
                                        onMouseEnter(index, 'first')
                                    }>
                                    <div
                                        className={`content-title ${
                                            firstIndex === v.key - 1
                                                ? 'active'
                                                : ''
                                        }`}>
                                        {v.title}
                                    </div>
                                    <div className="content-desc">{v.desc}</div>
                                </div>
                            ))}
                        </div>

                        <div className="large-title">
                            <div style={{ display: 'none' }}>
                                {intl.get('landingPage.landingPage.message59')}
                            </div>
                            <div style={{ display: 'none' }}>
                                {intl.get('landingPage.landingPage.message60')}
                            </div>
                            {intl.get('landingPage.landingPage.message61')}
                        </div>
                        <div className="sub-title">
                            {intl.get('landingPage.landingPage.message62')}
                        </div>

                        <div className="carousel-wrap">
                            <Carousel
                                // dots={{ className: 'custom-dot-landing-hdc' }}
                                autoplay
                                afterChange={cur =>
                                    handleCarouselChange(cur, 'second')
                                }
                                ref={carouselRef1}>
                                {TABS_2.map((v, index) => (
                                    <div className="carousel-card" key={index}>
                                        <div className="tab-content">
                                            <img
                                                src={v.content.img}
                                                alt={v.title}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </Carousel>
                        </div>

                        <div className="dot-content-wrap content-wrap-second">
                            {TABS_2.map((v, index) => (
                                <div
                                    className="dot-content-item"
                                    key={v.key}
                                    onClick={() =>
                                        onMouseEnter(index, 'second')
                                    }>
                                    <div
                                        className={`content-title ${
                                            secondIndex === v.key - 1
                                                ? 'active'
                                                : ''
                                        }`}>
                                        {v.title}
                                    </div>
                                    <div className="content-desc">{v.desc}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="example">
                    <div className="sub-content">
                        <div className="large-title">
                            <div style={{ display: 'none' }}>
                                {intl.get('landingPage.landingPage.message63')}
                            </div>
                            <div style={{ display: 'none' }}>
                                {intl.get('landingPage.landingPage.message64')}
                            </div>
                            {intl.get('landingPage.landingPage.message65')}
                        </div>
                        <div className="example-flex-wrap">
                            {EXAMPLE_LIST.map((v, index) => {
                                return (
                                    <div
                                        key={index}
                                        className="example-item"
                                        onClick={() => navigateTo(index)}>
                                        <div className="top">
                                            <img src={v.img} alt={v.company} />

                                            <div style={{ display: 'none' }}>
                                                {intl.get(
                                                    'landingPage.landingPage.message68'
                                                )}
                                            </div>
                                            <div style={{ display: 'none' }}>
                                                {intl.get(
                                                    'landingPage.landingPage.message67'
                                                )}
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <div className="bottom-sub">
                                                <div className="title">
                                                    {v.build}
                                                </div>
                                                <div className="desc">
                                                    {v.desc}
                                                </div>
                                            </div>

                                            <i className="outlined icon-Arrow"></i>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="large-title">
                            <div style={{ display: 'none' }}>
                                {intl.get('landingPage.landingPage.message68')}
                            </div>
                            <div style={{ display: 'none' }}>
                                {intl.get('landingPage.landingPage.message67')}
                            </div>
                            {intl.get('landingPage.landingPage.message70')}
                        </div>
                        <Logoes isHDC />
                    </div>
                </div>
                <div className="about-foxit">
                    <AboutFoxit
                        isHDC
                        middle={
                            <div className="free-use middle-top">
                                <div className="max-width-wrap">
                                    <div className="large-title">
                                        {intl.get(
                                            'landingPage.landingPage.message69'
                                        )}
                                    </div>
                                    <Form
                                        autoComplete="off"
                                        form={codeForm}
                                        layout="inline"
                                        onFinish={onVerification}>
                                        <Item
                                            name="fullName"
                                            messageVariables={intl.get(
                                                'landingPage.landingPage.inputName'
                                            )}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: intl.get(
                                                        'landingPage.landingPage.inputName'
                                                    ),
                                                },
                                            ]}>
                                            <Input
                                                allowClear
                                                className="first-item"
                                                placeholder={intl.get(
                                                    'landingPage.landingPage.inputName'
                                                )}
                                            />
                                        </Item>
                                        <Item
                                            name="mobile"
                                            validateFirst
                                            messageVariables={{
                                                label: intl.get(
                                                    'signUpSignIn.phoneNumber'
                                                ),
                                                // pattern: '手机号格式',
                                            }}
                                            rules={[
                                                {
                                                    required: true,
                                                },
                                                {
                                                    pattern:
                                                        /^1[3456789]\d{9}$/,
                                                    message: intl.get(
                                                        'signUpSignIn.inputCorrectPhoneNumber'
                                                    ),
                                                },
                                            ]}>
                                            <Input
                                                allowClear
                                                className="first-item"
                                                placeholder={intl.get(
                                                    'signUpSignIn.inputPhone'
                                                )}
                                            />
                                        </Item>

                                        <Item
                                            name="captcha"
                                            messageVariables={{
                                                label: intl.get(
                                                    'signUpSignIn.code'
                                                ),
                                            }}
                                            validateFirst
                                            rules={[
                                                {
                                                    required: true,
                                                    len: 6,
                                                },
                                            ]}>
                                            <Input
                                                type="number"
                                                placeholder={intl.get(
                                                    'signUpSignIn.inputCode'
                                                )}
                                                prefix={
                                                    <Button
                                                        disabled={isClicked}
                                                        type="text"
                                                        onClick={sendCode}
                                                        className="auth-code-btn">
                                                        {isClicked
                                                            ? intl.get(
                                                                  'signUpSignIn.interval',
                                                                  {
                                                                      count,
                                                                  }
                                                              )
                                                            : intl.get(
                                                                  'signUpSignIn.getCode'
                                                              )}
                                                    </Button>
                                                }
                                            />
                                        </Item>
                                        <Item className="submit-btn-wrap">
                                            <Button
                                                className="submitBtn"
                                                block
                                                loading={loading}
                                                type="primary"
                                                htmlType="submit">
                                                {intl.get(
                                                    'landingPage.landingPage.message71'
                                                )}
                                            </Button>
                                        </Item>
                                    </Form>
                                    <div className="small-tip">
                                        <span>
                                            <i className="outlined icon-check-circle"></i>
                                            {intl.get(
                                                'landingPage.landingPage.message72'
                                            )}
                                        </span>
                                        <span>
                                            <i className="outlined icon-check-circle"></i>
                                            {intl.get(
                                                'landingPage.landingPage.message73'
                                            )}
                                        </span>
                                    </div>
                                    <ServiceModal
                                        visible={isModalOpen}
                                        onCancel={() => setIsModalOpen(false)}
                                    />
                                </div>
                            </div>
                        }
                    />
                </div>
            </div>
        );
    })
);
